const ACCEPTED_FILE_EXTENSIONS = 'csv, xlsx, text, doc, docx, pptx, pdf, rtf, png, svg, jpeg';
const MAX_FILE_SIZE = 5;

export { ACCEPTED_FILE_EXTENSIONS, MAX_FILE_SIZE };
